module.exports = __webpack_public_path__ + "static/media/maxDailyLogin_1095.52415090.png";